export { useReviewCardMorphemePagePrefetch } from "#use-review-card-morpheme-page-prefetch";
